import { isMobile } from '@Constants/LeftDrawer';
import OwnableTheme from '@Theme';
import { utilStyles } from '@Utils/utilStyles';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components/native';

import { Text } from '../../../Common/Text';

const largeW = isMobile ? '82.5px' : '140px';
const smallW = isMobile ? '35.25px' : '60px';

const largeBR = isMobile ? '12px' : '20px';
const smallBR = isMobile ? '5.036px' : '10px';

const largeP = isMobile ? '8.813px' : '15px';

const largeS = isMobile ? 'xxxs' : 'm';
const smallS = isMobile ? 'x4s' : 'xxxs';

const StyledCardWrapper = styled.Pressable<{ size?: 'l' | 's' }>`
  width: ${({ size }) => (size === 'l' ? largeW : smallW)};
  height: ${({ size }) => (size === 'l' ? largeW : smallW)};
  border-radius: ${({ size }) => (size === 'l' ? largeBR : smallBR)};
  padding: ${({ size }) => (size === 'l' ? largeP : '0px')};
  background-color: black;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledCardImg = styled.Image`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-position: center;
`;

type Props = {
  url?: string;
  name: string;
  item: any;
  size?: 'l' | 's';
  onPress?: (value: number | string) => void;
};

const SeenThingsBrandCard: FC<Props> = ({
  url,
  name,
  size = 'l',
  onPress,
  item,
}) => (
  <StyledCardWrapper size={size} onPress={() => onPress?.(item)}>
    {url ? (
      <StyledCardImg key={url} resizeMode='contain' source={{ uri: url }} />
    ) : (
      <Text
        color={OwnableTheme.colors.white}
        weight='regular'
        align='left'
        size={size === 'l' ? largeS : smallS}
        fontStyleOverride={utilStyles.textAlignCenter}
      >
        {name}
      </Text>
    )}
  </StyledCardWrapper>
);

export default observer(SeenThingsBrandCard);
